module.exports = __webpack_public_path__ + "static/media/innowind-dem-bannerimg.da7302f6.jpg";